import { mapDTO } from '@twistezo/ts-dto-mapper'

import type { RichPlacementKWordsSlice } from '../types'
import type { GetRichPlacementKWordsQuery } from 'gql/graphql'

type From = GetRichPlacementKWordsQuery['workspaceRichPlacementKwordsConfiguration']
type To = RichPlacementKWordsSlice

export const fromDTO = (from: From): To =>
  mapDTO<From, To>({ from }).transform(
    ({ kwordsSiteId }: From): To => ({
      kwordsSiteId: kwordsSiteId ?? undefined,
    }),
  )
